import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { ISectionHost } from './section-host';
import { WaitingIndicatorComponent } from '../waiting-indicator/waiting-indicator.component';
import { DeviceManagerService } from '../../core/services/device-manager.service';

@Component({
	selector: 'mycampapp-section-host',
	templateUrl: './section-host.component.html',
	styleUrls: ['./section-host.component.less'],
	animations: WaitingIndicatorComponent.animations,
})
export class SectionHostComponent implements OnInit
{
	@Input() busy = false;
	@Input() showCampSiteBanner = false;
	@Input() showRightPane = false;
	@Input() hostComponent!: ISectionHost;
	@Input() hostComponentName = '';
	@Input() leftToolbar: TemplateRef<any> | null = null;
	@Input() leftPaneBody: TemplateRef<any> | null = null;
	@Input() rightPaneBody: TemplateRef<any> | null = null;

	constructor(public deviceManager: DeviceManagerService) { }

	ngOnInit(): void
	{
	}

}
